import { baseApi } from "api/BaseApi";

import {
  ProductFeature,
  GetFeaturesPayload,
  NewFeaturePayload,
  UpdateProductFeaturePayload,
} from "./productFeatures.types";

const PRODUCT_FEATURES_BASE_URL = "/features/product-features";

export const featuresApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getProductFeatures: build.query<ProductFeature[], GetFeaturesPayload>({
      query: (params) => ({
        url: `${PRODUCT_FEATURES_BASE_URL}/`,
        params,
      }),
      providesTags: (_result, _error, params) => {
        let id: string;
        if ("product_id" in params && params.product_id) {
          id = `product-${params.product_id}`;
        } else if ("pcm_id" in params && params.pcm_id) {
          id = `pcm-${params.pcm_id}`;
        } else if ("ccid" in params && params.ccid) {
          id = `ccid-${params.ccid}`;
        } else {
          id = "all";
        }
        return [{ type: "PRODUCT_FEATURES", id }];
      },
    }),

    createProductFeature: build.mutation<ProductFeature, NewFeaturePayload>({
      query: (body) => ({
        url: `${PRODUCT_FEATURES_BASE_URL}/`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, body) => [
        {
          type: "PRODUCT_FEATURES",
          id: "product" in body ? `product-${body.product}` : `pcm-${body.pcm}`,
        },
      ],
    }),

    deleteProductFeature: build.mutation<void, UpdateProductFeaturePayload>({
      query: (body) => ({
        url: `${PRODUCT_FEATURES_BASE_URL}/${body.id}/`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, body) => [
        {
          type: "PRODUCT_FEATURES",
          id: "product" in body ? `product-${body.product}` : `pcm-${body.pcm}`,
        },
      ],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetProductFeaturesQuery,
  useCreateProductFeatureMutation,
  useDeleteProductFeatureMutation,
} = featuresApi;
